module.exports = __webpack_public_path__ + "img/123-before-blue.0e9169fd.png";